import ky, { HTTPError, type Options } from 'ky';

import { getAuthHeaders, redirectInvalidUser } from './auth';
import { APP_SCOPE_HEADER, LABORATORY_API_URL } from './env';

const UNAUTHORIZED = 401;

export const laboratoryApi = ky.create({
  prefixUrl: LABORATORY_API_URL,
  retry: { limit: 1, methods: ['get'] },
  timeout: 30_000,
  hooks: {
    beforeRequest: [
      (request) => {
        Object.entries(getAuthHeaders()).forEach(([header, value]) => {
          request.headers.set(header, value);
        });
        request.headers.set('X-Scope', APP_SCOPE_HEADER);
      },
    ],
    afterResponse: [
      (_request, _options, response) => {
        if (response.status === UNAUTHORIZED) redirectInvalidUser();
        return response;
      },
    ],
  },
});

export type QueryParamValue = string | number | boolean | null | undefined;

export function toSearchParams(params: Record<string, QueryParamValue>): Record<string, string> {
  return Object.entries(params).reduce<Record<string, string>>((accumulator, [key, value]) => {
    if (value === null || value === undefined || value === '') return accumulator;

    accumulator[key] = String(value);
    return accumulator;
  }, {});
}

export async function extractErrorMessage(error: unknown): Promise<string | null> {
  if (!(error instanceof HTTPError)) return null;

  try {
    const body: unknown = await error.response.clone().json();

    if (typeof body !== 'object' || body === null || !('message' in body)) return null;

    const { message } = body as { message: unknown };

    return typeof message === 'string' ? message : null;
  } catch {
    return null;
  }
}

export type RequestOptions = Options;
